/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContractPaymentCreateDto } from '../../models/sales-contract-payment-create-dto';
import { SalesContractPaymentResponseDto } from '../../models/sales-contract-payment-response-dto';

export interface ContractPaymentsControllerCreate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
      body: SalesContractPaymentCreateDto
}

export function contractPaymentsControllerCreate(http: HttpClient, rootUrl: string, params: ContractPaymentsControllerCreate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractPaymentResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, contractPaymentsControllerCreate.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesContractPaymentResponseDto>;
    })
  );
}

contractPaymentsControllerCreate.PATH = '/o2-sales/contract-payments/{tenant}';
